import type { ItemsByTypeAndId } from '../../types';
import type { SideContent } from '../side-content';
import { prop } from '../prop';
import { riskLevelTemplateId } from '../templates';
import { getTaskData } from './getTaskData';
import { pageIds } from '../pages/pageIds';

export function getItemDataFromTemplateId(
  n: string,
  itemsByTypeAndId: ItemsByTypeAndId,
  singleUserVersion: boolean,
): SideContent | undefined {
  let type = '';
  let target = '';
  let startTask = false;
  let name = '';
  let helpContent = '';
  let content = '';
  const source: Pick<
    ItemsByTypeAndId,
    | 'contracts'
    | 'documents'
    | 'guidelines'
    | 'functions'
    | 'reports'
    | 'constitutionalDocuments'
    | 'riskAssessments'
    | 'tasks'
    | 'meetings'
  > = itemsByTypeAndId;

  const a: (keyof typeof source)[] = [
    'contracts',
    'documents',
    'guidelines',
    'functions',
    'reports',
    'constitutionalDocuments',
    'riskAssessments',
    'tasks',
    'meetings',
  ];
  a.forEach((t) => {
    const c = prop(source, t);
    Object.keys(c).forEach((uuid) => {
      if (c[uuid].mainTemplateId === +n) {
        type = t;
        const item = c[uuid];
        name = item.name ?? '';
        helpContent = item.helpContent ?? '';
        /**
         * Special case: risk level guideline is located on risk assessments page
         */
        if (c[uuid].mainTemplateId === riskLevelTemplateId) {
          target = pageIds.riskAssessments + '/guidelines/' + uuid;
        } else if (t === 'meetings') {
          target = pageIds.meetings + '/' + t + '/' + uuid;
        } else if (t === 'riskAssessments') {
          target = pageIds.riskAssessments + '/' + t + '/' + uuid;
        } else if (t === 'constitutionalDocuments') {
          target = pageIds.company + '/' + t + '/' + uuid;
        } else if (t === 'tasks') {
          const taskData = getTaskData(uuid, itemsByTypeAndId, singleUserVersion);
          if (taskData.name) {
            name = taskData.name;
          }
          if (taskData.startTask) {
            startTask = true;
          }
          target = taskData.target;
        } else if ('pages' in item && item.pages?.length) {
          target = '' + item.pages[0] + '/' + t + '/' + uuid;
        }
        if (t === 'functions') {
          content = item['description'] ?? '';
        } else if (t === 'tasks' || t === 'meetings') {
          content = item['procedures'] ?? '';
        } else {
          content = item['content'] ?? '';
        }
      }
    });
  });
  if (target) {
    return {
      type,
      target,
      startTask,
      name,
      helpContent,
      content,
    };
  }
  return undefined;
}
